import React from "react";
import { Colour } from "../../theme/theme";
import { useTheme } from "@emotion/react";

export type LoadingSize = "sm" | "md" | "lg";

export interface LoadingProps {
  size?: LoadingSize;
  colour?: Colour;
}

const BaseSizeMap: { [key in LoadingSize]: number } = {
  sm: 40,
  md: 60,
  lg: 80,
};

const Loading: React.FC<LoadingProps> = (props) => {
  const theme = useTheme();
  const colour = props.colour || "primary";
  const size = props.size || "sm";
  const baseSize = BaseSizeMap[size];

  return (
    <div
      css={{
        display: "inline-block",
        position: "relative",
        width: `${baseSize}px`,
        height: `${baseSize}px`,
        "& div": {
          position: "absolute",
          border: `${baseSize / 20}px solid ${theme.colours[colour]["400"]}`,
          opacity: 1,
          borderRadius: "50%",
          animation: `lds-ripple-${size} 1s cubic-bezier(0, 0.2, 0.8, 1) infinite`,
        },
        "& div:nth-of-type(2)": {
          animationDelay: "-0.5s",
        },
        "@keyframes lds-ripple-sm": {
          "0%": {
            top: `16px`,
            left: `16px`,
            width: 0,
            height: 0,
            opacity: 0,
          },
          "4.9%": {
            top: `16px`,
            left: `16px`,
            width: 0,
            height: 0,
            opacity: 0,
          },
          "5%": {
            top: `16px`,
            left: `16px`,
            width: 0,
            height: 0,
            opacity: 1,
          },
          "100%": {
            top: 0,
            left: 0,
            width: `32px`,
            height: `32px`,
            opacity: 0,
          },
        },
        "@keyframes lds-ripple-md": {
          "0%": {
            top: `26px`,
            left: `26px`,
            width: 0,
            height: 0,
            opacity: 0,
          },
          "4.9%": {
            top: `26px`,
            left: `26px`,
            width: 0,
            height: 0,
            opacity: 0,
          },
          "5%": {
            top: `26px`,
            left: `26px`,
            width: 0,
            height: 0,
            opacity: 1,
          },
          "100%": {
            top: 0,
            left: 0,
            width: `52px`,
            height: `52px`,
            opacity: 0,
          },
        },
        "@keyframes lds-ripple-lg": {
          "0%": {
            top: `36px`,
            left: `36px`,
            width: 0,
            height: 0,
            opacity: 0,
          },
          "4.9%": {
            top: `36px`,
            left: `36px`,
            width: 0,
            height: 0,
            opacity: 0,
          },
          "5%": {
            top: `36px`,
            left: `36px`,
            width: 0,
            height: 0,
            opacity: 1,
          },
          "100%": {
            top: 0,
            left: 0,
            width: `72px`,
            height: `72px`,
            opacity: 0,
          },
        },
      }}
    >
      <div></div>
      <div></div>
    </div>
  );
};

export default Loading;
